import { types } from '../reducers/downloadableFileReducer';

// eslint-disable-next-line import/prefer-default-export
export const createDownloadableFile = (values) => ({
  type: types.POST,
  payload: values,
});

export const updateDownloadableFile = (values) => ({
  type: types.PUT,
  payload: values,
});

export const removeDownloadableFile = (index) => ({
  type: types.DELETE,
  index,
});

export const resetDownloadableFile = () => ({
  type: types.RESET,
});

export { getDraftId } from '../reducers/downloadableFileReducer';
